<template>
  <section class="product-selection">
    <a :class="['button', 'show-product-filter', {hide: !filterHiddenOnMobile}]"
       href="#"
       @click.prevent="filterHiddenOnMobile=false"
       v-html="$t('productOverview.showFilter')"
    />
    <filter-chip-bar :entities="filterEntities"
                     :filter-hidden-on-mobile="filterHiddenOnMobile"
                     :include-clear-all-button="shopConfig.includeClearAllFilterButton"
                     @clearAllClicked="clearFilterEntitySelection"
                     @entityClicked="unselectFilterEntity"
    />
    <div :class="['overview-filter', 'row', {hide: filterHiddenOnMobile}]">
      <form action="#">
        <slot/>
      </form>
    </div>
    <a :class="['button', 'hide-product-filter', {hide: filterHiddenOnMobile}]"
       href="#"
       @click.prevent="filterHiddenOnMobile=true"
       v-html="$t('productOverview.hideFilter')"/>
  </section>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import productFilter from './ProductFilter'
import FilterChipBar from './FilterChipBar'

export default {
  components: {
    FilterChipBar,
    productFilter
  },
  props: {
    includeClearAllButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      filterHiddenOnMobile: true
    }
  },
  computed: {
    ...mapGetters('selection', [
      'sortedSelectedFilterEntities'
    ]),
    ...mapGetters('shop', [
      'overviewFilterTypes'
    ]),
    ...mapState({
      shopConfig: state => state.shop.shopConfig
    }),
    filterEntities: function () {
      return this.sortedSelectedFilterEntities.filter(entity => this.overviewFilterTypes.includes(entity.__typename))
    }
  },
  methods: {
    ...mapActions('selection', [
      'unselectFilterEntity',
      'unselectFilterEntities'
    ]),
    clearFilterEntitySelection: async function () {
      await this.unselectFilterEntities(this.sortedSelectedFilterEntities)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductFilterBar.vue